import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UploadFileRequestModel, UploadFileResponseModel } from "@/features/accounts/ocr/services/upload-file-model";

export class UploadFileApi {
  /**
   * OCR取込ファイルアップロードAPI
   */
  public UploadFile = async (
    param: UploadFileRequestModel
  ): Promise<UploadFileResponseModel> => {
    const path = `/api/ocraccounts/uploadfile`;

    // FormDataとして送信
    const formData = new FormData();
    formData.append("account_group_id", param.account_group_id);
    formData.append("ocr_account_id", param.ocr_account_id);
    param.upload_file.slice(0, 5).forEach((file) => {
      formData.append("upload_file", file);
    });

    const res = await ApiClient.instance.postBytes<UploadFileResponseModel>({
      path: path,
      params: formData as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
